module.exports = __webpack_public_path__ + "img/MG_4723-scaled.02068685.jpg";